import React, { useContext } from "react";

import DateRangePicker from "@wojtekmaj/react-daterange-picker";

import { reportContext } from "contexts/ReportContext";

function DateRangeMenuItem() {
	const reportData = useContext(reportContext);
	return (
		<>
			<span
				style={{
					fontWeight: "700",
					fontSize: "16px",
					color: "grey",
					paddingRight: "10px",
				}}
			>
				Showing results for:
			</span>
			<DateRangePicker
				maxDate={new Date()}
				value={reportData.captureDate}
				onChange={(e) => reportData.setCaptureDate(e)}
			/>
		</>
	);
}

export default DateRangeMenuItem;
